import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  ARCHIVED_COMPANIES_ROUTE,
  AUTH_MFA_ROUTE,
  AUTH_NEW_PASSWORD_ROUTE,
  AUTH_SIGNIN_ROUTE,
  BUYER_DETAILS_ROUTE,
  BUYERS_ROUTE,
  COMPANIES_ROUTE,
  COMPANY_DETAILS_ROUTE,
  HOME_ROUTE,
  ORDER_DETAILS_ROUTE,
  ORDERS_ROUTE,
  PENDING_INVITATIONS_ROUTE,
  REPORT_ROUTE,
  SCRIPTS_ROUTE,
  SELLER_DETAILS_ROUTE,
  SELLERS_ROUTE,
  STEPS_ROUTE,
  STORE_DETAILS_ROUTE,
  STORES_ROUTE,
  UNPAID_ROUTE,
  VOP_REQUIEST_ROUTE,
  SETTINGS_ROUTE,
  PRODUCT_CATEGORY_ROUTE,
  PRODUCT_SUBCATEGORY_ROUTE,
  CLUSTER_ROUTE,
} from '../shared/constants/routes';
import {
  BUYER_DETAILS_EVENTS_TAB_LABEL,
  BUYER_DETAILS_GENERAL_TAB_LABEL,
  BUYER_DETAILS_ORDER_TAB_LABEL,
  COMPANY_DETAILS_EVENTS_TAB_LABEL,
  COMPANY_DETAILS_GENERAL_TAB_LABEL,
  COMPANY_DETAILS_STORE_TAB_LABEL,
  COMPANY_DETAILS_TEAM_TAB_LABEL,
  COMPANY_PENDING_INVITATION_LABEL,
  COMPANY_DETAILS_UNPAID_TAB_LABEL,
  NavigationItemLabel,
  ORDER_DETAILS_DECIDO_TAB_LABEL,
  ORDER_DETAILS_EVENTS_TAB_LABEL,
  ORDER_DETAILS_GENERAL_TAB_LABEL,
  ORDER_DETAILS_INSTALLMENTS_TAB_LABEL,
  ORDER_DETAILS_QINETIC_TAB_LABEL,
  SELLER_DETAILS_EVENTS_TAB_LABEL,
  SELLER_DETAILS_GENERAL_TAB_LABEL,
  STORE_DETAILS_EVENTS_TAB_LABEL,
  STORE_DETAILS_GENERAL_TAB_LABEL,
  STORE_DETAILS_TEAM_TAB_LABEL,
  SETTINGS_PRODUCT_CATEGORIES_LABEL,
  SETTINGS_CLUSTER_LABEL,
} from '../shared/constants/translations';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  navigation_set: NavigationSet = new NavigationSet();

  constructor(private router: Router) {}

  toAuthSignin(): void {
    this.router.navigate([AUTH_SIGNIN_ROUTE]);
  }

  toAuthNewPassword(): void {
    this.router.navigate([AUTH_NEW_PASSWORD_ROUTE]);
  }

  toAuthMfa(): void {
    this.router.navigate([AUTH_MFA_ROUTE]);
  }

  toHome(): void {
    this.router.navigate([HOME_ROUTE]);
  }

  toCompanies(): void {
    this.router.navigate([COMPANIES_ROUTE]);
  }

  toSellers(): void {
    this.router.navigate([SELLERS_ROUTE]);
  }

  toPendingInvitations(): void {
    this.router.navigate([PENDING_INVITATIONS_ROUTE]);
  }

  toStores(): void {
    this.router.navigate([STORES_ROUTE]);
  }

  toOrders(): void {
    this.router.navigate([ORDERS_ROUTE]);
  }

  toBuyers(): void {
    this.router.navigate([BUYERS_ROUTE]);
  }

  toSteps(): void {
    this.router.navigate([STEPS_ROUTE]);
  }

  toArchive(): void {
    this.router.navigate([ARCHIVED_COMPANIES_ROUTE]);
  }

  toUnpaid(): void {
    this.router.navigate([UNPAID_ROUTE]);
  }

  toScripts(): void {
    this.router.navigate([SCRIPTS_ROUTE]);
  }

  toVopRequest(): void {
    this.router.navigate([VOP_REQUIEST_ROUTE]);
  }

  toBuyerDetails(buyer_id: string): void {
    this.router.navigate([`${BUYER_DETAILS_ROUTE}/${buyer_id}`]);
  }

  toCompanyDetails(company_id: string): void {
    this.router.navigate([`${COMPANY_DETAILS_ROUTE}/${company_id}`]);
  }

  toProductSubCategory(product_category_id: string): void {
    this.router.navigate([`${PRODUCT_SUBCATEGORY_ROUTE}/${product_category_id}`]);
  }

  toProductCategory(): void {
    this.router.navigate([PRODUCT_CATEGORY_ROUTE]);
  }

  toCluster(): void {
    this.router.navigate([CLUSTER_ROUTE]);
  }

  toSettings(): void {
    this.router.navigate([SETTINGS_ROUTE]);
  }

  toOrderDetails(store_id: string, order_id: string): void {
    this.router.navigate([`${ORDER_DETAILS_ROUTE}/${store_id}/${order_id}`]);
  }

  toSellerDetails(seller_id: string): void {
    this.router.navigate([`${SELLER_DETAILS_ROUTE}/${seller_id}`]);
  }

  toStoreDetails(company_id: string, store_id: string): void {
    this.router.navigate([`${STORE_DETAILS_ROUTE}/${company_id}/${store_id}`]);
  }

  toGenericPath(path: string): void {
    this.router.navigate([path]);
  }
}

export class NavigationSet {
  nav_items: Map<string, NavigationItem>;
  settings_items: Map<string, SettingNavigationItem>;
  order_details_tabs = new Map<string, string>([
    ['article', ORDER_DETAILS_GENERAL_TAB_LABEL],
    ['list', ORDER_DETAILS_INSTALLMENTS_TAB_LABEL],
    ['arrow_split', ORDER_DETAILS_DECIDO_TAB_LABEL],
    ['computer', ORDER_DETAILS_QINETIC_TAB_LABEL],
    ['timeline', ORDER_DETAILS_EVENTS_TAB_LABEL],
  ]);

  store_details_tabs = new Map<string, string>([
    ['article', STORE_DETAILS_GENERAL_TAB_LABEL],
    ['group', STORE_DETAILS_TEAM_TAB_LABEL],
    ['receipt_long', BUYER_DETAILS_ORDER_TAB_LABEL],
    ['timeline', STORE_DETAILS_EVENTS_TAB_LABEL],
    ['mail_outline', COMPANY_PENDING_INVITATION_LABEL],
  ]);

  company_details_tabs = new Map<string, string>([
    ['article', COMPANY_DETAILS_GENERAL_TAB_LABEL],
    ['storefront', COMPANY_DETAILS_STORE_TAB_LABEL],
    ['group', COMPANY_DETAILS_TEAM_TAB_LABEL],
    ['receipt_long', BUYER_DETAILS_ORDER_TAB_LABEL],
    ['money_off', COMPANY_DETAILS_UNPAID_TAB_LABEL],
    ['timeline', COMPANY_DETAILS_EVENTS_TAB_LABEL],
    ['mail_outline', COMPANY_PENDING_INVITATION_LABEL],
  ]);

  seller_details_tabs = new Map<string, string>([
    ['article', SELLER_DETAILS_GENERAL_TAB_LABEL],
    ['timeline', SELLER_DETAILS_EVENTS_TAB_LABEL],
  ]);

  buyer_details_tabs = new Map<string, string>([
    ['article', BUYER_DETAILS_GENERAL_TAB_LABEL],
    ['receipt_long', BUYER_DETAILS_ORDER_TAB_LABEL],
    ['timeline', BUYER_DETAILS_EVENTS_TAB_LABEL],
  ]);

  constructor() {
    this.nav_items = new Map<string, NavigationItem>();
    this.nav_items.set(NavigationItemLabel.home, {
      label: NavigationItemLabel.home,
      path: HOME_ROUTE,
      icon: 'dashboard',
    });
    this.nav_items.set(NavigationItemLabel.orders, {
      label: NavigationItemLabel.orders,
      path: ORDERS_ROUTE,
      icon: 'receipt_long',
    });
    this.nav_items.set(NavigationItemLabel.buyers, {
      label: NavigationItemLabel.buyers,
      path: BUYERS_ROUTE,
      icon: 'person',
    });
    this.nav_items.set(NavigationItemLabel.steps, {
      label: NavigationItemLabel.steps,
      path: STEPS_ROUTE,
      icon: 'payments',
    });
    this.nav_items.set(NavigationItemLabel.companies, {
      label: NavigationItemLabel.companies,
      path: COMPANIES_ROUTE,
      icon: 'apartment',
    });
    this.nav_items.set(NavigationItemLabel.stores, {
      label: NavigationItemLabel.stores,
      path: STORES_ROUTE,
      icon: 'storefront',
    });
    this.nav_items.set(NavigationItemLabel.sellers, {
      label: NavigationItemLabel.sellers,
      path: SELLERS_ROUTE,
      icon: 'group',
    });
    this.nav_items.set(NavigationItemLabel.pending_invitations, {
      label: NavigationItemLabel.pending_invitations,
      path: PENDING_INVITATIONS_ROUTE,
      icon: 'mail_outline',
    });
    this.nav_items.set(NavigationItemLabel.report, {
      label: NavigationItemLabel.report,
      path: REPORT_ROUTE,
      icon: 'leaderboard',
    });
    this.nav_items.set(NavigationItemLabel.unpaid, {
      label: NavigationItemLabel.unpaid,
      path: UNPAID_ROUTE,
      icon: 'money_off',
    });
    this.nav_items.set(NavigationItemLabel.scripts, {
      label: NavigationItemLabel.scripts,
      path: SCRIPTS_ROUTE,
      icon: 'code',
    });
    this.nav_items.set(NavigationItemLabel.vop_request, {
      label: NavigationItemLabel.vop_request,
      path: VOP_REQUIEST_ROUTE,
      icon: 'assured_workload',
    });
    this.nav_items.set(NavigationItemLabel.settings, {
      label: NavigationItemLabel.settings,
      path: SETTINGS_ROUTE,
      icon: 'settings',
    });

    this.settings_items = new Map<string, SettingNavigationItem>();
    this.settings_items.set(SETTINGS_PRODUCT_CATEGORIES_LABEL, {
      label: SETTINGS_PRODUCT_CATEGORIES_LABEL,
      path: PRODUCT_CATEGORY_ROUTE,
    });
    this.settings_items.set(SETTINGS_CLUSTER_LABEL, {
      label: SETTINGS_CLUSTER_LABEL,
      path: CLUSTER_ROUTE,
    });
  }
}

export enum NavbarStatus {
  open = 'open',
  closed = 'closed',
}

export class NavigationItem {
  label?: NavigationItemLabel;
  path?: string;
  icon?: string;
}

export class SettingNavigationItem {
  label?: string;
  path?: string;
}
